import { Pipe, PipeTransform } from '@angular/core';
import { SignalTag } from '../../app/models/SignalTag';

/**
 * Generated class for the TagsSearchPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'tagsSearch'
})
export class TagsSearchPipe implements PipeTransform {

  transform(value: Array<SignalTag>, q: string) {
    if (q === null || q === '' || q === undefined) {
      return value;
    }
    return value.filter(tag =>
      tag.tagName != null
        ? tag.tagName.toLowerCase().indexOf(q.toLowerCase()) > -1 ||
        tag.tagDescription.toLowerCase().indexOf(q.toLowerCase()) > -1
        : null
    );
  }
}



// WEBPACK FOOTER //
// ./src/pipes/tags-search/tags-search.ts